import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { SubmitPaymentParam } from "features/stock-ordering/core/stock-ordering.params";
import {
  SubmitPaymentRepository,
  PaymentActionResponse,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum SubmitPaymentState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: SubmitPaymentState;
  message: string;
}

const initialState: InitialState = {
  status: SubmitPaymentState.initial,
  message: "",
};

export const submitPayment = createAsyncThunk(
  "submitPayment",
  async (param: SubmitPaymentParam, { rejectWithValue }) => {
    try {
      const response: PaymentActionResponse =
        await SubmitPaymentRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  },
);

export const submitPaymentSlice = createSlice({
  name: "submitPayment",
  initialState,
  reducers: {
    resetSubmitPayment: (state) => {
      state.status = SubmitPaymentState.initial;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitPayment.pending, (state) => {
        state.status = SubmitPaymentState.inProgress;
      })
      .addCase(submitPayment.fulfilled, (state, action) => {
        if (action.payload) {
          state.status = SubmitPaymentState.success;
          state.message = action.payload.message;
        }
      })
      .addCase(submitPayment.rejected, (state, action) => {
        state.status = SubmitPaymentState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectSubmitPayment = (state: RootState) => state.submitPayment;
export const { resetSubmitPayment } = submitPaymentSlice.actions;
export default submitPaymentSlice.reducer;
